import { AuthState } from '../types';

export function login(state: AuthState) {
  state.isLoggedIn = true;
  state.loading = false;
  state.error = null;

  localStorage.setItem('app_logged_in', 'true');
}
